import { S3Object } from "../../models";

export interface CogginsDataFormState {
    accessionNumber: string;
    date: string | null;
    state: string;
}

export interface CogginsDocumentFormState {
    fileTitle?: string;
    fileObject?: File | null;
    s3Object?: S3Object | null;
}

export interface CogginsSectionRequirements {
    requiresCogginsData?: boolean | null;
    requiresCogginsDocument?: boolean | null;
}

function hasValue(value: string | null | undefined): boolean {
    return value !== null && value !== undefined && String(value).trim() !== "";
}

function hasCogginsDocument(document: CogginsDocumentFormState): boolean {
    return Boolean(document.s3Object || document.fileObject);
}

/** Whether all event-required Coggins fields are filled for the Entry form section chip. */
export function isCogginsSectionComplete(
    data: CogginsDataFormState,
    document: CogginsDocumentFormState,
    requirements: CogginsSectionRequirements
): boolean {
    if (requirements.requiresCogginsData) {
        if (!hasValue(data.accessionNumber)) return false;
        if (!hasValue(data.date)) return false;
        if (!hasValue(data.state)) return false;
    }

    if (requirements.requiresCogginsDocument) {
        if (!hasCogginsDocument(document)) return false;
    }

    return true;
}
